<template>
  <div class="publication-container">
    <div class="item-background"></div>
    <div class="item-container">
      <div class="title-line">Selected Publications</div>
      <div class="publication-content">

        ● Qiang Yue, Mengzhao Wang, Xiaoliang Xu, Cheng Long, Yuxiang Wang, Jiahui Wang. Efficient and Robust Out-of-Distribution Vector Similarity Search with Cross-Distribution Monotonic Graph (SIGMOD, CCF A), 2026<br />

        ● Yuxiang Wang, Zhangyang Peng, Xiaoliang Xu, Xiangyu Ke, Tianxing Wu, Yuan Gao. Cohesiveness-aware Hierarchical Compressed Index for Community Search over Attributed Graphs (SIGMOD, CCF A), 2025<br />

        ● Xiaoxuan Gou, Weiguo Zheng, Yuxiang Wang, Xiaoliang Xu, Zhiyuan Yu. A Comprehensive Survey and Experimental Study of Learning-based Community Search (VLDB, CCF A), 2025  <br />

        ● Qiang Yue, Xiaoliang Xu*, Yuxiang Wang, et al., Routing-Guided Learned Product Quantization for Graph-Based Approximate Nearest 
          Neighbor Search, International Conference on Data Engineering (ICDE, CCF A), 2024 <br />

        ● Mengzhao Wang, Weizhi Xu, …, Xiaoliang Xu*, et al., Starling: An I/O-Efficient Disk-Resident Graph Index Framework for 
        High-Dimensional Vector Similarity Search on Data Segment, ACM SIGMOD International Conference on Management of Data 
        (SIGMOD, CCF A), 2024<br />

        ● Mengzhao Wang, Xiangyu Ke, Xiaoliang Xu, et al., MUST: An Effective and Scalable Framework for Multimodal Search with 
        Target Modality International Conference on Data Engineering (ICDE, CCF A), 2024.<br />

        ● Mengzhao Wang, Lingwei Lv, Xiaoliang Xu*, Yuxiang Wang, Qiang Yue, Jiongkang Ni, An Efficient and Robust Framework 
        for Approximate Nearest Neighbor Search with Attribute Constraint, Conference on Neural Information Processing Systems 
        (NeurIPS, CCF A), 2023<br />
        
        ● Shuzhan Ye, Xiaoliang Xu, Yuxiang Wang*, Tao Fu, Efficient Complex Aggregate Queries with Accuracy Guarantee based on 
        Execution Cost Model over Knowledge Graphs, Mathematics, 2023, 11(18), 3908; DOI: 10.3390/math11183908 <br />

        ● Xiaoxun Gou, Xiaoliang Xu, Xiangying Wu, Runhuai Chen, Yuxiang Wang*, Tianxing Wu, Xiangyu Ke ,Effective and Efficient 
        Community Search with Graph Embeddings，ECAI 2023, Volume 372, p891-898. <br />
        
        ● Yuxiang Wang, Jun Liu, Xiaoliang Xu*, Efficient and Effective Academic Expert Finding on Heterogeneous Graphs through 
        (k,P)-Core based Embedding[J], ACM Transactions on Knowledge Discovery from Data,2023,17(6): 85:1-85:35. <br />


        ● Yuxiang Wang, Arijit Khan,Xiaoliang Xu*, Jiahui Jin, Qifan Hong, Tao
          Fu . Aggregate Queries on Knowledge Graphs: Fast Approximation with
          Semantic-aware Sampling. . ICDE 2022. (CCF A)
        <br />
        ● Xiaoliang Xu, Jun Liu, Yuxiang Wang*, Xiangyu Ke. Academic
        Expert Finding via (K,P)-Core based Embedding over Heterogeneous Graphs.
        ICDE 2022. (CCF A) <br />
        ●	Yuxia Geng, Jiaoyan Chen, Zhiquan Ye, et al., 
          Explainable Zero-shot Learning via Attentive Graph Convolutional Network and Knowledge Graphs, Semantic Web Journal (SWJ) 2021, SCI (IF=3.524). <br />
        ●	Yuxia Geng, Jiaoyan Chen, Zhuo Chen, et al., OntoZSL: Ontology-enhanced Zero-shot Learning, WWW 2021, CCF-A.<br />
        ●	Yuxia Geng, Jiaoyan Chen, et al., Disentangled Ontology Embedding for Zero-shot Learning, KDD 2022, CCF-A.<br />
        ● Mengzhao Wang, Xiaoliang Xu, Qiang Yue,
        Yuxiang Wang*. A Comprehensive Survey and Experimental Comparison of
        Graph-Based Approximate Nearest Neighbor Search. VLDB 2021. (CCF A)
        <br />
        ●	Yuxia Geng, Jiaoyan Chen, et al., Human-centric Transfer Learning Explanation via Knowledge Graph, AAAI 2019, CCF-A.<br />
        ● Yuxia Geng, Jiaoyan Chen, Wen Zhang, et al., Relational Message Passing for Fully Inductive Knowledge Graph Completion, ICDE 2023 (accept with minor revision), CCF-A.<br />
        ● Yuxiang Wang, Arijit Khan, Tianxing Wu, Jiahui Jin, Haijiang
        Yan. Semantic Guided and Response Times Bounded Top-k Similarity Search
        over Knowledge Graphs. ICDE 2020: 445-456. (CCF A, acceptance ratio
        19.5%) <br />
        ● Xiaoliang Xu, Xin Jin*, Rui Yan, et al. Visual pattern
        recognition using enhanced visual features and PSD-based learning rule.
        IEEE Transactions on Cognitive and Developmental Systems (TCDS), 2017,
        10(2): 205-212. (JCR R2) <br />
        ● Yuxiang Wang, Jun Liu, Xiaoliang Xu, Xiangyu Ke, 
        Tianxing Wu, Xiaoxuan Gou. Efficient and Effective Academic Expert Finding on 
        Heterogeneous Graphs through (k,P)-Core based Embedding. 
        Transactions on Knowledge Discovery from Data (TKDD), 2022, Accepted. (CCF B, IF=4.157)<br />
        ● Xiaoliang Xu, Qifan Hong, Yuxiang Wang*, Jiahui Jin, Xinle Xuan, Tao Fu. A Random Walk 
        Sampling on Knowledge Graphs for Semantic-oriented Statistical Tasks. Data & Knowledge Engineering, 2022. (CCF B)<br />
        ● Yuxiang Wang, Xiaoliang Xu*, Qifan
        Hong, et al. Top-k Star Queries on Knowledge Graphs Through
        Semantic-aware Bounding Match Scores, Knowledge-Based Systems (KBS),
        2021, Volume 213(2):106655. (CCF B, JCR R1) <br />
        ● Xiaoliang Xu,
        Mengzhao Wang, Yuxiang Wang, Dingcheng Ma. Two-Stage Routing with
        Optimized Guided Search and Greedy Algorithm on Proximity Graph.
        Knowledge-based Systems (KBS), 2021. (CCF B, JCR R1) <br />

        ●	Yuxia Geng, Jiaoyan Chen, Xiang Zhuang, et al., Benchmarking Knowledge-driven Zero-shot Learning, Journal of Web. Semantics (JWS), CCF-B. <br />
        ●	Jiaoyan Chen, Yuxia Geng, et al., Knowledge-aware Zero-Shot Learning: Survey and Perspective, IJCAI 2021, CCF-A. <br />
        ●	Zhiquan Ye, Yuxia Geng, et al., Zero-shot Text Classification via Reinforced Self-training, ACL 2020, CCF-A. <br />
        ●	Jiaoyan Chen, Yuxia Geng, Zhuo Chen, et al., Low-resource Learning with Knowledge Graphs: A Comprehensive Survey,submitted to Proceedings 
        of the IEEE (Proc. IEEE), CCF-A, 96 related works, 223 citations, 36 pages in double columns. <br />
        ●	Jiaoyan Chen, Freddy Lecue, Yuxia Geng, Ontology-guided Semantic Composition for Zero-shot Learning, KR 2020, CCF-B. ◦ Zhuo Chen, Jiaoyan Chen, 
        Yuxia Geng, Zero-Shot Visual Question Answering Using Knowledge Graph, ISWC 2021, CCF-B.<br />



        ● Xiaoliang
        Xu, Chang Li, Yuxiang Wang*, et al. Multiattribute Approximate Nearest
        Neighbor Search Based on Navigable Small World Graph. Concurrency and
        Computation:Practice and Experience (CCPE), 2020, 32(24). (CCF C)
        <br />
        ● Xiaoliang Xu, Tong Gao, Yuxiang Wang*, et al. Event Temporal
        Relation Extraction with Attention Mechanism and Graph Neural Network.
        Tsinghua Science and Technology, (2020-12-15录用). (JCR R3) <br />
        ●Jiahui Jin, Xiaoxuan Zhu, Biwei Wu, Jinghui Zhang, Yuxiang Wang. A
        Dynamic and Deadline-Oriented Road Pricing Mechanism for Urban Traffic
        Management. Tsinghua Science and Technology, 2020. (JCR R3) <br />
        <!-- 以下为过老成果 -->
        <!--●Yuxiang Wang, Zhangpeng Ge, Haijiang Yan, Xiaoliang Xu*, et al. Semantic
        Locality based Approximate Knowledge Graph Query. Concurrency and
        Computation:Practice and Experience (CCPE), 2019, 31(24):1-13. (CCF C)
        <br />
        
         ● Yuxiang Wang, Jiahui Jin, Xiaoliang Xu*, et al. Skew-aware
        online aggregation over joins through guided sampling. Concurrency and
        Computation: Practice and Experience (CCPE), 2018, 30(20):
        e4695.1-e4695.17. (CCF C) <br />
        ● Yuxiang Wang, Yixing Xia, Qiming Fang,
        Xiaoliang Xu*. AQP++: a hybrid approximate query processing framework
        for generalized aggregation queries. Journal of computational science
        (JOCS), 2018, 26: 419-431. (JCR R3) <br />
        ● Xiaoliang Xu, Wensi Lu,
        Qiming Fang*, et al. A Visual Recognition Model Based on Hierarchical
        Feature Extraction and Multi-layer SNN. International Conference on
        Neural Information Processing (ICONIP), 2018: 525-534. (CCF C) <br />
        ●
        Yuxiang Wang, Junzhou Luo, Aibo Song, Fang Dong. A Sampling-Based Hybrid
        Approximate Query Processing System in the Cloud. ICPP 2014: 291-300.
        (CCF B) <br />
        ● Yuxiang Wang, Junzhou Luo, Aibo Song, Jiahui Jin, Fang
        Dong. Improving Online Aggregation Performance for Skewed Data
        Distribution. DASFAA 2012: 18-32. (CCF B) <br />
        ● Yuxiang Wang, Junzhou
        Luo, Aibo Song, Fang Dong. OATS: online aggregation with two-level
        sharing strategy in cloud. Distributed Parallel Databases, 32(4):
        467-505, 2014. (CCF C) <br />
        ● Yuxiang Wang, Junzhou Luo, Aibo Song,
        Fang Dong. Partition-Based Online Aggregation with Shared Sampling in
        the Cloud. Journal of Computer Science and Technology, 28(6): 989-1011,
        2013. (CCF B, JCR R2) -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.documentElement.scrollTop = 0;
  },
};
</script>

<style scoped>
.publication-container {
  min-height: 100vh;
}
.item-background {
  height: 60px;
}
.item-container {
  width: 60%;
  margin: 0px auto;
}
.title-line {
  margin: 32px auto;
  font-family: Microsoft YaHei;
  font-size: 40px;
  font-weight: 300;
  color: #333;
  text-align: center;
}
.publication-content {
  font-size: 20px;
  /* font-weight: bold; */
  line-height: 36px;
}
@media screen and (max-width: 900px) {
  .item-container {
    width: 85%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/publication/index.vue